import React from "react";
import PropTypes from "prop-types";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../../styles.css";
const SuggestionContainer = _ref => {
  let {
    children,
    classes
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classes['list-container']
  }, children);
};
process.env.NODE_ENV !== "production" ? SuggestionContainer.propTypes = {
  children: PropTypes.node,
  classes: classesPropType(['container', 'is-open', 'list-container', 'list', 'item', 'item-is-disabled', 'item-is-active'])
} : void 0;
export default withClasses(styles)(SuggestionContainer);